/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useCallback, use } from 'react';
import axios from 'axios';
import { Image, Input, message, Button } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDragAndDrop } from '../../../../../../../context/DragDropContext';
import { postRequest } from '../../../../../../../core/apiRequests';

const UploadAttachmentModal = ({ onClose, collection, fetchCollectionProducts }) => {
  const [attachmentDescription, setAttachmentDescription] = useState('');
  const { fileData, imageHandler, setMaxFilesSize, setMaxFilesSizeHuman, clearFiles } = useDragAndDrop();

  useEffect(() => {
    setMaxFilesSize(1e+9); // Set max file size to 1GB
    setMaxFilesSizeHuman('1GB'); // Set human-readable size
  }, [setMaxFilesSize, setMaxFilesSizeHuman]);

  const saveCollectionAttachment = useCallback(async () => {

    const file = fileData?.images.files?.[0] || fileData?.videos.videoFrames.files?.[0] || fileData?.pdfs.files?.[0];
    if (!file) return;
    const reqObj = {
      params: ['uploads', 'presigned-url'],
      data: {
        fileType: file.type,
        attachmentType: 'collection',
      },
    };
    try {
      const { fileName, fileUrl, presignedUrl } = await postRequest(reqObj);
      // Upload file to S3 using presigned URL
      const response = await axios.put(presignedUrl, file, {
        headers: {
          'Content-Type': file.type, // Must match what the URL expects
          Authorization: null,
        },
      });
      // Now save the attachment details to your backend
      const attachmentData = {
        fileName,
        fileType: file.type,
        url: fileUrl,
        description: attachmentDescription,
      };
      // Example API call to save attachment details
      const attachmentRes = await postRequest({ params: ['collections', collection?.id, 'addAttachments'], data: attachmentData });
      fetchCollectionProducts();
      message.success('Attachment uploaded successfully');
    } catch (err) {
      message.error('Failed to upload attachment');
    } finally {
      onClose();
    }
  }, [fileData, attachmentDescription, collection]);

  return (
    <div
      className="pop-confirm-background"
      id="modal-background"
      onClick={e => {
        if (e.target.id === 'modal-background') {
          onClose();
        }
      }}
    >
      <div
        className="pop-confirm-container rem-pad-width "
        style={{ width: '500px', minHeight: '278px', maxHeight: '520px', overflowY: 'hidden' }}
      >
        <div
          className="flex-col-center"
          style={{
            justifyContent: 'flex-start',
            padding: '0 18px 12px 28px',
            maxHeight: '500px',
          }}
        >
          <div className="flex-row-spacebetween-nowrap w-100-P m-top-15" />
          <span className="fs-18 fw-600" style={{ marginTop: '15px', marginBottom: '16px' }}>
            Upload Attachment
          </span>
          <div className="flex-row-center w-100-P scrollbar-y">
            {(fileData.images.urls.length > 0 || fileData?.videos.videoFrames.urls.length > 0 || fileData?.pdfs.urls.length > 0) ? (
              <Image
                src={fileData?.images.urls?.[0] || fileData?.videos.videoFrames.urls?.[0] || fileData?.pdfs.urls?.[0]}
                height={150}
                alt="attachment"
                style={{ maxHeight: '300px', maxWidth: '100%', borderRadius: '8px' }}
                preview={{
                  mask: <FontAwesomeIcon icon={['far', 'trash']} size="2x" />,
                }}
                fallback='https://dashboard-v2-images.s3.us-east-1.amazonaws.com/pdf-fallback.svg'
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  clearFiles();
                }}
              />
            ) : (
              <div className="flex-col-center" style={{ cursor: 'pointer', color: '#33AAFC', height: '150px', width: '150px', backgroundColor: '#E6F4FF', borderRadius: '8px' }}
                onClick={() => document.getElementById('media-input').click()}
              >
                <FontAwesomeIcon icon="far fa-paperclip" size='2x' />
                <span style={{ marginTop: '10px', fontSize: '18px' }}>Add File</span>
              </div>
            )}
            <input
              id="media-input"
              type="file"
              accept=".jpg, .jpeg, .png, .gif, .svg, .pdf"
              onChange={e => {
                imageHandler(e.target.files);
                e.target.value = null; // Clear the input value after handling files
              }}
              style={{ display: 'none' }}
            />
            <p className="p-left-20 gray">Must be image or pdf less than 1GB.
              <br />
              (.jpeg, .png, .gif, .svg, .pdf)
            </p>
          </div>
          <div className="flex-col-left w-100-P m-top-20">
            <span className="fs-14 fw-500 p-left-10">Attachment Description:</span>
            <Input.TextArea
              placeholder="Enter attachment description"
              style={{ width: '100%', marginTop: '8px' }}
              value={attachmentDescription}
              onChange={e => setAttachmentDescription(e.target.value)}
            />
          </div>
          <div className="flex-row-center" style={{ marginTop: '38px', marginBottom: '8px', gap: '12px' }}>
            <Button size="large" onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              disabled={(fileData.images.urls.length === 0 && fileData?.videos.videoFrames.urls.length === 0 && fileData?.pdfs.urls.length === 0) || !attachmentDescription}
              onClick={saveCollectionAttachment}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadAttachmentModal;
